<template>
    <div class="flex flex-col items-center justify-center flex-1 h-full p-4">
        <UserRoundX :size="48" class="text-red-500 dark:text-red-400 mb-4" />
        <p class="text-center">
            {{ $t('error.noSingleSignOnAccount') }}
        </p>
        <Button
            :aria-label="$t('ariaLabel.logOutButton')"
            class="w-full md:w-auto mt-8"
            @click="onLogOutClick"
            :disabled="loading"
            severity="secondary"
            size="small"
            :label="$t('logOut')"
            variant="text">
            <template #icon>
                <LogOut />
            </template>
        </Button>
    </div>
</template>

<script lang="ts">
import { LogOut, UserRoundX } from 'lucide-vue-next';
import { logOut as logOutRequest } from '@api/log-out';

export default {
    components: {
        LogOut,
        UserRoundX
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        async onLogOutClick() {
            this.loading = true;
            await logOutRequest();
            window.location.href = '/';
            this.loading = false;
        }
    }
};
</script>
